import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger"]

  open(event) {
    if (event.defaultPrevented) return
    if (!this.hasTriggerTarget) return
    if (this.ignoreClick(event.target)) return

    this.triggerTarget.click()
  }

  ignoreClick(target) {
    return target.closest("a, button, input, select, textarea, label, summary, [data-row-open-ignore], [contenteditable='true']")
  }
}
